<template>
<div>
    <Breadcrumbs main="Admin" submain="Course" title="Partner" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Partner</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="partner_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title" style="max-width: 300px;">
                                            <h7>{{ row.item.title }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(link)="row">
                                        <div v-if="row.item.link" style="max-width: 350px;">
                                            <a :href="row.item.link" target="_blank" rel="noopener noreferrer">
                                                <span v-if="row.item.link?.length < 40">{{ row.item.link }}</span>
                                                <span v-else>{{ row.item.link?.slice(0, 40) + '...' }}</span>
                                            </a>
                                        </div>
                                    </template>

                                    <template #cell(logo)="row">
                                        <div v-if="row.item.logo" style="min-width: 120px;">
                                            <img style="max-height: 80px;" :src="host + row.item.logo" alt="">
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deletePartner(data.item.slug)" title="Delete"></feather>
                                            </div>
                                            <div @click="editPartner(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Partner Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Course Partner" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter partner's name" v-model="partner.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter partner's link" v-model="partner.link">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div style="display: flex; flex-direction: column;">
                        <label>Logo</label>
                        <input type="file" accept="image/*" @change="onLogoChange($event, 'logo')" />
                    </div>
                    <div v-if="logoPreview" style="margin-top: 20px;">
                        <img :src="logoPreview" alt="Banner Preview" style="max-width: 100%; max-height: 100px;" />
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Partner Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Course Partner" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter course title" v-model="edit_partner.title">
                    </div>
                </div>
            </div> 
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter course link" v-model="edit_partner.link">
                    </div>
                </div>
            </div> 
            <div class="row">
                <div class="col-sm-12">
                    <div style="display: flex; flex-direction: column;">
                        <label>Logo</label>
                        <input type="file" accept="image/*" @change="onLogoChangeEdit($event, 'logo')" />
                    </div>
                    <div v-if="logoPreview" style="margin-top: 20px;">
                        <img :src="logoPreview" alt="Banner Preview" style="max-width: 100%; max-height: 100px;" />
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Partner Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this partner?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'link',
                    label: 'Link',
                    sortable: true
                },
                {
                    key: 'logo',
                    label: 'Logo',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            partner: {
                title: "",
                link: null,
                logo: null
            },
            edit_partner: {
                slug: null,
                title: "",
                link: null,
                logo: null
            },
            delete_value: null,
            logoPreview: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            partner_list: state => state.partner.partner,
            loading: state => state.partner.partnerLoading,
            error: state => state.partner.partnerError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("partner/fetchPartner").then(() => {
            this.items = this.partner_list
            this.totalRows = this.partner_list.length;
        });
    },

    methods: {
        onLogoChange(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'logo') {
                    this.partner.logo = e.target.result;
                    this.logoPreview = e.target.result;
                } 
            };
        },

        onLogoChangeEdit(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'logo') {
                    this.edit_partner.banner = e.target.result;
                    this.logoPreview = e.target.result;
                } 
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.partner.title = ""
            this.partner.link = ""
            this.partner.logo = null
            this.logoPreview = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("partner/addPartner", this.partner).then(response => {
                if (response.code == 201) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                   this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editPartner(detail) {
            this.edit_partner.slug = detail.slug ? detail.slug : null
            this.edit_partner.title = detail.title ? detail.title : null
            this.edit_partner.link = detail.link ? detail.link : null
            this.logoPreview = detail.logo ? this.host + detail.logo : null
        },

        resetEditModal() {
            this.edit_partner.slug = null
            this.edit_partner.title = null
            this.edit_partner.link = null
            this.edit_partner.banner = null
            this.logoPreview = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("partner/updatePartner", {
                id: this.edit_partner.slug,
                partner: this.edit_partner
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deletePartner(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("partner/deletePartner", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
